module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_c('h3', {
    staticClass: "title sr-only"
  }, [_c('span', [_vm._v("About us")])]), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "articles-box aboutus-box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('figure', {
    staticClass: "pic articles-pic"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "/static/images/aboutus-1.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('h4', {
    staticClass: "title text-primary"
  }, [_vm._v("Music\n                                                    "), _c('br'), _vm._v("Through Time")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("音樂是可以跳脫時間定律的神奇魔法！\n"), _c('br'), _vm._v("人會老相片會泛黃，影片雖可以紀錄，\n"), _c('br'), _vm._v("卻沒有閉上眼睛聽著歌，\n"), _c('br'), _vm._v("帶人瞬間穿越時空，回到過去的想像力！")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "articles-box aboutus-box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 push-md-6"
  }, [_c('figure', {
    staticClass: "pic articles-pic"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "/static/images/aboutus-2.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 pull-md-6"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('h4', {
    staticClass: "title text-primary"
  }, [_vm._v("Turning Love "), _c('br'), _vm._v("into Forever")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("婚禮歌曲常被挑選的原因，\n"), _c('br'), _vm._v("只因為旋律好聽、搭配婚禮儀式方便，\n"), _c('br'), _vm._v("對歌詞的含意和適用時機，缺少真正的了解，\n"), _c('br'), _vm._v("一個讓婚姻歷久彌新、愛意永不退色的契機因而錯過。\n"), _c('br'), _vm._v(" "), _c('br'), _vm._v("不論你是新人或婚禮顧問，\n"), _c('br'), _vm._v("希望在這裡可以找到屬於新人特有的婚禮歌曲。\n"), _c('br'), _vm._v(" "), _c('br'), _vm._v("我們相信用心選擇的婚禮歌曲，\n"), _c('br'), _vm._v("會跨越貴賤、身分、國界，為婚姻帶來真摯的祝福。\n"), _c('br'), _vm._v("我們歡迎新人分享婚禮歌曲影片，\n"), _c('br'), _vm._v("讓幸福的聲音可被更多人聽見！")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "articles-box aboutus-box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('figure', {
    staticClass: "pic articles-pic"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "/static/images/aboutus-3.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('h4', {
    staticClass: "title text-primary"
  }, [_vm._v("Wedding Song\n"), _c('br'), _c('small', {
    staticClass: "sub-title"
  }, [_vm._v("桅頂上聽見幸福的聲音")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("不管是入港，還是要出航\n"), _c('br'), _vm._v("桅頂上，我聽見嚮往，我看見方向")])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46cba209","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/About.vue
// module id = 162
// module chunks = 1